import React from 'react';
import { IResultRequest } from '@vivli/features/results-request/infrastructure/interface';
import { ResultsRequestStatusEnum } from '@vivli/features/results-request/infrastructure/enum';
import { FieldHeaderComponent } from '@vivli/shared/components';
import { ResultRequestFormatService, ResultRequestPermissionService } from '@vivli/features/results-request/infrastructure/service';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';
import { Size } from '@vivli/shared/theme';
import { useActiveUserContext, useAppConfigContext } from '@vivli/core/infrastructure/context';
import { ResultRequestApprovalComponent } from './result-request-approval.component';
import { DownloadOnlyDataPackageFeature } from '@vivli/shared/features/data-package/feature';
import { LoadIndicatorView } from '@vivli/shared/views';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

interface ResultRequestComponentProps {
    resultRequest: IResultRequest;
    dataRequest: IDataRequest;
    onRequestChanged?: (request: IResultRequest) => void;
}

export const ResultRequestComponent = ({ resultRequest, dataRequest, onRequestChanged }: ResultRequestComponentProps) => {
    const { user, hasPermission } = useActiveUserContext();
    const config = useAppConfigContext();

    if (!resultRequest) {
        return <LoadIndicatorView />;
    }

    const RequestFailedComponent = () => {
        return (
            <div style={{ marginTop: '40px', width: '470px' }}>
                <FieldHeaderComponent style={{ color: 'red' }} title="Results Request has failed review with the following comment:" />
                <div style={{ marginLeft: 25, marginTop: 10, color: 'red' }}>{resultRequest.reviewComments}</div>
            </div>
        );
    };

    // check this first so that Vivli Admins see the correct display for Disapproved and HeuristicsRequireReview
    // only show this view for normal application (aka viewRequestResultsOnly === false)
    if (ResultRequestPermissionService.canApproveDeny(resultRequest, user) && !config.viewRequestResultsOnly) {
        return (
            <>
                {resultRequest.resultsRequestStatus === ResultsRequestStatusEnum.Disapproved && <RequestFailedComponent />}
                <div style={{ marginTop: Size.INSET_SIZE }} className={'scrolly'}>
                    <ResultRequestApprovalComponent
                        resultRequest={resultRequest}
                        dataRequestId={dataRequest.id}
                        onResultApproved={onRequestChanged}
                        onResultDisapproved={onRequestChanged}
                    />
                </div>
            </>
        );
    }

    if (resultRequest.resultsRequestStatus === ResultsRequestStatusEnum.Disapproved) {
        return <RequestFailedComponent />;
    } else if (resultRequest.resultsRequestStatus === ResultsRequestStatusEnum.RetrievingResultsFailed) {
        return (
            <div style={{ marginTop: '40px', width: 500 }}>
                <FieldHeaderComponent title="Results retrieval failed.  Please contact administrator." />
            </div>
        );
    } else if (resultRequest.resultsRequestStatus === ResultsRequestStatusEnum.Approved) {
        return (
            <div style={{ marginTop: Size.INSET_SIZE }} className={'scrolly'}>
                <span style={{ marginBottom: '15px' }}>
                    Result Request Status: {ResultRequestFormatService.formatStatus(resultRequest.resultsRequestStatus, user)}
                </span>

                {
                    //TODO PERMFE - redo with permissions+
                    (ResultRequestPermissionService.canDownloadFiles(resultRequest, dataRequest, user) ||
                        hasPermission(PermissionsEnum.DrActAdv)) && (
                        <DownloadOnlyDataPackageFeature dataPackageId={resultRequest.resultsDataPackageId} />
                    )
                }
            </div>
        );
    }

    return (
        <div style={{ marginTop: '40px', width: '294px' }}>
            <FieldHeaderComponent title="Results not yet available for this request." />
        </div>
    );
};
